export const getAccessRequests = (state) => state.accessRequests.accessRequests
export const getSelectedRequest = (state) => state.accessRequests.selectedRequest
export const getIsSubmitting = (state) => state.accessRequests.isSubmitting
export const getRole = (state) => state.accessRequests.role
export const getConsent = (state) => state.accessRequests.consent
export const getIsPlaceUser = (state) => state.accessRequests.isPlaceUser
export const getModalView = (state) => state.accessRequests.view
